"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ExcelImport;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("../../Button"));
var _Spin = _interopRequireDefault(require("../../Spin"));
var _Modal = _interopRequireDefault(require("../../Modal"));
var _Upload = _interopRequireDefault(require("../../Upload"));
var _ykbStyledComponents = _interopRequireDefault(require("../../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Dragger = (0, _ykbStyledComponents.default)(_Upload.default.Dragger).withConfig({
  componentId: "ykb-ui__sc-18z7j5c-0"
})(["> div:first-child{background-color:", ";height:180px;margin-bottom:20px;}.ykb-upload{> div{margin-top:10px;}}"], function (props) {
  return props.theme.color.default1;
});
var Wrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-18z7j5c-1"
})(["text-align:center;display:flex;flex-direction:row;justify-content:space-between;align-items:center;"]);
var Info = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-18z7j5c-2"
})(["margin-bottom:10px;"]);
var Col = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-18z7j5c-3"
})(["flex:1;"]);
var ErrorList = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-18z7j5c-4"
})(["margin-top:20px;color:", ";"], function (props) {
  return props.theme.color.error6;
});
var Error = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-18z7j5c-5"
})([""]);
function ExcelImport(_ref) {
  var excelModalVisible = _ref.excelModalVisible,
    setExcelModalVisible = _ref.setExcelModalVisible,
    options = _ref.options;
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    fileList = _useState2[0],
    setFileList = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    spinning = _useState4[0],
    setSpinning = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    errors = _useState6[0],
    setErrors = _useState6[1];
  (0, _react.useEffect)(function () {
    setFileList([]);
    setErrors([]);
  }, [excelModalVisible]);
  var onClose = options.onClose,
    onSuccess = options.onSuccess,
    onError = options.onError,
    extraData = options.extraData,
    url = options.url;
  var props = {
    accept: '.xlsx, xls, csv',
    onStart: function onStart(file) {
      if (fileList.length != 0) {
        setErrors(['Sadece bir dosya yüklemesi yapılabilir.']);
        return;
      }
    },
    onRemove: function onRemove(file) {
      setFileList([]);
      setErrors([]);
    },
    beforeUpload: function beforeUpload(file) {
      if (fileList.length != 0) {
        return;
      }
      setFileList([file]);
      return false;
    },
    fileList: fileList
  };
  function handleClose() {
    if (onClose) {
      onClose();
    }
    setExcelModalVisible(false);
  }
  var uploadImage = function uploadImage() {
    var formData = new FormData();
    for (var name in extraData) {
      formData.append(name, extraData[name]);
    }
    fileList.forEach(function (file) {
      formData.append('requestFile', file);
    });
    setSpinning(true);
    fetch(url, {
      method: 'post',
      body: formData,
      credentials: 'include',
      headers: {
        'x-process-id': "ykb-ui-excelimport",
        'x-hmn-sessionid': window.hmnSessionId || 'NA'
      }
    }).then(function (response) {
      return response.json();
    }).then(function (result) {
      if (onSuccess) {
        onSuccess(result);
      }
      setExcelModalVisible(false);
    }).catch(function (error) {
      if (onError) {
        onError(error);
      }
      setErrors(error.errorMessage ? (0, _toConsumableArray2.default)(error.errorMessage) : ['Beklenmedik Bir Hata oluştu']);
    }).finally(function () {
      setSpinning(false);
    });
  };
  function handleSubmit() {
    if (fileList.length > 0) {
      uploadImage();
    }
  }
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    title: "Excel Y\xFCkle",
    visible: excelModalVisible,
    onClose: handleClose,
    footer: [/*#__PURE__*/_react.default.createElement(_Button.default, {
      key: "back",
      onClick: handleClose,
      disabled: spinning
    }, "VAZGE\xC7"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      key: "submit",
      type: "primary",
      onClick: handleSubmit,
      disabled: spinning
    }, "KAYDET")]
  }, /*#__PURE__*/_react.default.createElement(_Spin.default, {
    spinning: spinning
  }, /*#__PURE__*/_react.default.createElement(Dragger, props, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(Col, null, /*#__PURE__*/_react.default.createElement(Info, null, "Dosyalar\u0131 Buraya S\xFCr\xFCkle", /*#__PURE__*/_react.default.createElement("br", null), "YA DA"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    style: {
      marginRight: 0
    },
    type: "primary"
  }, "DOSYA SE\xC7")))), errors && errors.length > 0 && /*#__PURE__*/_react.default.createElement(ErrorList, null, errors.map(function (error) {
    return /*#__PURE__*/_react.default.createElement(Error, null, error);
  }))));
}